module.exports = __webpack_public_path__ + "static/landingpage_icons_v2-07-cd615455224dfbd2a084692f1fa313b9.png";